<!-- @if (showSpinner) {
<app-loader> </app-loader>
} -->

<div class="main-wrapper">
  <div class="outer-wrapper">
    <div class="payroll-summary-footer">
      <div class="payroll-subcomponent common-graph-section">
        <div class="common-head">
          <div class="comon-left-head borderless" *ngIf="!showSkeleton">
            <svg (click)="goBack()" width="18" height="14" viewBox="0 0 18 14" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M17 7H1M1 7L7 13M1 7L7 1" stroke="#2D2D2E" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <h1>Employee Salary Info</h1>

          </div>
          <div class="payroll-summary-header-body-item release-amount skeleton-small-div skiliton-buttons"
            *ngIf="showSkeleton"></div>
          <div class="comon-right">
            <div *ngIf="!showSkeleton" class="common-btn salary-info" (click)="goToAddPayroll()">
              <img src="../../../../assets/theme1/smal-icons/green-eye.svg" alt="missing icon">
              View Processing Payroll
            </div>
            <div *ngIf="!showSkeleton" class="common-btn request-loan" data-toggle="modal" data-target="#payrollModal">
              <img src="../../../../assets/theme1/smal-icons/plus-circle.svg" alt="missing icon">
              Add New Payroll
            </div>
            <div class="payroll-summary-header-body-item release-amount skeleton-small-div skiliton-buttons"
              *ngIf="showSkeleton"></div>
            <div class="payroll-summary-header-body-item release-amount skeleton-small-div skiliton-buttons"
              *ngIf="showSkeleton"></div>
          </div>
        </div>
        <div class="common-head filters">
          <div class="comon-left-head borderless filter-head">
            <h1 *ngIf="!showSkeleton">Filter</h1>
            <div class="payroll-summary-header-body-item release-amount skeleton-small-div skiliton-buttons"
              *ngIf="showSkeleton"></div>

          </div>
          <div class="comon-right">
            <div class="input-group" *ngIf="!showSkeleton">
              <div class="input-wrapper">
                <input type="text" placeholder="Search here..." [(ngModel)]="filters.name" />

                <!-- Search Icon -->
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="#a0aec0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </div>
            </div>

            <div class="input-group" *ngIf="!showSkeleton">
              <div class="input-wrapper">
                <select [(ngModel)]="filters.role_id"> <!-- bind to filters.role_id -->
                  <option value="" disabled selected>Select Role</option>
                  <option *ngFor="let role of user_Roles" [value]="role.id">{{ role.role_name }}</option>
                </select>
              </div>
            </div>


            <!-- Apply filter button -->
            <div *ngIf="!showSkeleton" class="common-btn request-loan apply-filter" (click)="getUserList()">
              Apply
            </div>
            <!-- Reset filter button -->
            <div *ngIf="!showSkeleton" class="common-btn reset-filter" (click)="resetFilters()">
              Reset
            </div>


            <div class="payroll-summary-header-body-item release-amount skeleton-small-div skiliton-buttons"
              *ngIf="showSkeleton"></div>
            <div class="payroll-summary-header-body-item release-amount skeleton-small-div skiliton-buttons"
              *ngIf="showSkeleton"></div>
            <div class="payroll-summary-header-body-item release-amount skeleton-small-div skiliton-buttons"
              *ngIf="showSkeleton"></div>
          </div>
        </div>

        <!-- <div class="filter-section">
                        <h1>Filter</h1>
                        <div class="filter-fields">
                           
                             
                            <button class="apply-filter" >Apply</button>
                        </div>
                    </div> -->

        <div class="table-container">
          <table class="responsive-table">
            <thead>

              <tr>
                <th>User</th>
                <th>Gross Salary</th>
                <th>Last Released Salary</th>
                <th>Date Of Joining</th>
                <th>Tenure</th>
                <th>Role</th>
                <th>Employment Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="showSkeleton">
                <td colspan="8">
                  <div class="skeleton-row" *ngFor="let n of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]">
                    <div class="skeleton-cell" *ngFor="let i of [1,2,3,4,5,6,7,8]"></div>
                  </div>
                </td>
              </tr>
              <ng-container *ngIf="!showSkeleton">
                <tr class="userlist-tr" *ngFor="let user of userList">
                  <td class="user-detail" (click)="openPreview(user)">
                    <div class="user-image">
                      <img [src]="user.profile_image || 'assets/default-avatar.png'" alt="profile"
                        class="profile-img" />
                    </div>
                    {{ user.first_name }} {{ user.last_name }}
                  </td>
                  <td>{{ payrollService.showValues ? (user.gross_salary | number) : '****' }}</td>
                  <td>{{ payrollService.showValues ? (user.last_released_salary ?? 0 | number) : '****' }}</td>
                  <td>{{ user.joining_date | date:'dd-MM-yyyy' }}</td>
                  <td>{{ user.tenure }}</td>
                  <td>{{ user.role }}</td>
                  <td>

                    <div class="status-comon" [ngClass]="{
                                            'permanent': user.employment_type === 'Permanent',
                                            'inter': user.employment_type === 'Interne',
                                            'prohibition': user.employment_type === 'Probabtion'
                                        }">
                      {{ user.employment_type }}
                    </div>
                  </td>

                  <td class="action-eye">
                    <!-- <img src="../../../../assets/theme1/smal-icons/green-plus-svg.svg" alt="plus icon"
                      (click)="editCase(user)" /> -->
                    <img src="../../../../assets/theme1/smal-icons/green-plus-svg.svg" alt="plus icon"
                      (click)="setSelectedUser(user)" data-toggle="modal" data-target="#userpayrollModal" />

                    <img (click)="openPreview(user)" src="../../../../assets/theme1/smal-icons/eye-purple.svg"
                      alt="eye icon" />
                  </td>
                </tr>
              </ng-container>


            </tbody>
          </table>
          <div class="pagination-wrapper" *ngIf="!showSkeleton && lastPage > 1">
            <button (click)="prevPage()" [disabled]="currentPage === 1">
              <img src="../../../../assets/theme1/smal-icons/left-arrow.png" alt="missing">
            </button>

            <button *ngFor="let page of [].constructor(lastPage); let i = index" (click)="goToPage(i+1)"
              [class.active]="currentPage === (i+1)">
              {{ i+1 }}
            </button>

            <button (click)="nextPage()" [disabled]="currentPage === lastPage">
              <img src="../../../../assets/theme1/smal-icons/right-arrow.png" alt="missing">
            </button>
          </div>
        </div>


      </div>




    </div>
  </div>
</div>






<div class="modal fade payroll-modal pl-0" id="payrollModal" tabindex="-1" role="dialog" aria-labelledby="basicModal"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content payroll-modal-content">
      <div class="modal-header payroll-modal-header justify-content-center">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img src="../../../../assets/theme1/smal-icons/circle-black-cross.png" alt="image">
        </button>
      </div>

      <div class="modal-body payroll-modal-body text-center payroll-modal-body">
        <img src="../../../../assets/theme1/smal-icons/calendar-3d.png" alt="image">
        <h1 class="mt-3">Select Month</h1>
        <div class="month-picker">
          <div class="month-picker-header">
            <button (click)="prevYear()">
              <img src="../../../../assets/theme1/smal-icons/left-arrow.png" alt="missing icon">
            </button>
            <span>{{ currentYear }}</span>
            <button (click)="nextYear()">
              <img src="../../../../assets/theme1/smal-icons/right-arrow.png" alt="missing icon">
            </button>
          </div>

          <div class="month-grid">
            <div *ngFor="let month of months; let i = index" class="month-cell" [class.selected]="i === selectedMonth"
              (click)="payrolselectMonth(i)">
              {{ month }}
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>


<div class="modal fade payroll-modal pl-0" id="userpayrollModal" tabindex="-1" role="dialog"
  aria-labelledby="basicModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content payroll-modal-content">
      <div class="modal-header payroll-modal-header justify-content-center">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img src="../../../../assets/theme1/smal-icons/circle-black-cross.png" alt="image">
        </button>
      </div>

      <div class="modal-body payroll-modal-body text-center payroll-modal-body">
        <img src="../../../../assets/theme1/smal-icons/calendar-3d.png" alt="image">
        <h1 class="mt-3">Select Month</h1>
        <div class="month-picker">
          <div class="month-picker-header">
            <button (click)="prevYear()">
              <img src="../../../../assets/theme1/smal-icons/left-arrow.png" alt="missing icon">
            </button>
            <span>{{ currentYear }}</span>
            <button (click)="nextYear()">
              <img src="../../../../assets/theme1/smal-icons/right-arrow.png" alt="missing icon">
            </button>
          </div>

          <div class="month-grid">
            <div *ngFor="let month of months; let i = index" class="month-cell" [class.selected]="i === selectedMonth"
              (click)="userPayrolselectMonth(i)">
              {{ month }}
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>